<script setup lang="ts">
import { save, close } from "ionicons/icons";
import {
  IonLabel,
  IonPage,
  IonItem,
  IonList,
  IonGrid,
  IonButton,
  IonLoading,
  IonIcon,
  IonRow,
  IonSelect,
  IonSelectOption,
  IonCol,
  IonFooter,
  IonContent,
  onIonViewDidEnter,
  useIonRouter,
} from "@ionic/vue";
import { useRoute } from "vue-router";
import { handleError, useForm } from "@/views";
import { useContextStore } from "@/stores/context";
import { reactive } from "vue";
import {
  getVisitorFormSettings,
  updateVisitorFormSettings,
} from "@/api/events";
import { useToasters } from "@/composition/toasters";
import { IVisitorFormSettings } from "@/models/event";

const contextStore = useContextStore();
const router = useIonRouter();
const toasters = useToasters();
const { form_settings } = useForm();
const route = useRoute();
const event_id = parseInt(route.params.event_id as string, 10);

let ogSettings: Partial<IVisitorFormSettings> = {
  phone_number: "v",
  birthdate: "v",
  job_title: "v",
  company: "v",
  country: "v",
};
const state = reactive({
  loading: false,
  form_enabled: true,
});

const submit = async () => {
  state.loading = true;
  if (state.form_enabled) {
    // settings.static_fields = settings.static_fields.map((field) => ({
    //   id: field.id,
    //   title: undefined,
    //   active: field.active,
    // }));
    // const promises = settings.static_fields
    //   .filter((static_field) => static_field.active)
    //   .map((static_field) => updateAttendingField(static_field));
    // state.loading = true;
    // await Promise.all(promises);
    // state.loading = false;
  }

  updateVisitorFormSettings({
    ...form_settings,
    event_id: contextStore.event.id,
  })
    .then(() => {
      toasters.addSuccess("Visitor form update successful!");
      state.loading = false;
    })
    .catch((err) => {
      state.loading = false;
      handleError(err);
    });
};

// getAttendingFields({ event: contextStore.event.id })
//   .then((response) => {
//     const fields = response.data.results;
//     settings.static_fields = fields.map((field) => ({
//       active: false,
//       title: field.title,
//       id: field.id,
//     }));
//     state.loading = false;
//   })
//   .catch((err) => {
//     state.loading = false;
//   });
onIonViewDidEnter(() => {
  state.loading = true;
  getVisitorFormSettings(event_id)
    .then((response) => {
      state.loading = false;
      ogSettings = response.data;
      form_settings.company = ogSettings.company;
      form_settings.country = ogSettings.country;
      form_settings.job_title = ogSettings.job_title;
      form_settings.phone_number = ogSettings.phone_number;
      form_settings.birthdate = ogSettings.birthdate;
    })
    .catch((err) => {
      handleError(err);
      state.loading = false;
    });
});
</script>
<template>
  <ion-page>
    <ion-content>
      <section>
        <ion-item>
          <ion-label>
            <h1>Event registration form</h1>
            <p>Details you want to collect from visitors.</p>
          </ion-label>
        </ion-item>

        <ion-list v-if="state.form_enabled">
          <ion-item>
            <ion-label>Phone number</ion-label>

            <ion-select
              placeholder="Select field use"
              v-model="form_settings.phone_number"
              interface="popover"
            >
              <ion-select-option value="m">Mandatory</ion-select-option>
              <ion-select-option value="v">Visible</ion-select-option>
              <!-- <ion-select-option value="h">Hidden</ion-select-option> -->
            </ion-select>
          </ion-item>
          <ion-item>
            <ion-label>Birthdate</ion-label>

            <ion-select
              placeholder="Select field use"
              v-model="form_settings.birthdate"
              interface="popover"
            >
              <ion-select-option value="m">Mandatory</ion-select-option>
              <ion-select-option value="v">Visible</ion-select-option>
              <!-- <ion-select-option value="h">Hidden</ion-select-option> -->
            </ion-select>
          </ion-item>
          <ion-item>
            <ion-label>Country</ion-label>

            <ion-select
              placeholder="Select field use"
              v-model="form_settings.country"
              interface="popover"
            >
              <ion-select-option value="m">Mandatory</ion-select-option>
              <ion-select-option value="v">Visible</ion-select-option>
              <!-- <ion-select-option value="h">Hidden</ion-select-option> -->
            </ion-select>
          </ion-item>
          <ion-item>
            <ion-label>Company</ion-label>

            <ion-select
              placeholder="Select field use"
              v-model="form_settings.company"
              interface="popover"
            >
              <ion-select-option value="m">Mandatory</ion-select-option>
              <ion-select-option value="v">Visible</ion-select-option>
              <!-- <ion-select-option value="h">Hidden</ion-select-option> -->
            </ion-select>
          </ion-item>
          <ion-item>
            <ion-label>Job title</ion-label>

            <ion-select
              value="v"
              placeholder="Select field use"
              v-model="form_settings.job_title"
              interface="popover"
            >
              <ion-select-option value="m">Mandatory</ion-select-option>
              <ion-select-option value="v">Visible</ion-select-option>
              <!-- <ion-select-option value="h">Hidden</ion-select-option> -->
            </ion-select>
          </ion-item>
        </ion-list>
      </section>
    </ion-content>

    <ion-footer>
      <div class="container">
        <section>
          <ion-grid>
            <ion-row>
              <ion-col>
                <ion-button expand="block" color="light" @click="router.back()">
                  <ion-icon slot="start" :icon="close"></ion-icon>
                  Cancel
                </ion-button>
              </ion-col>
              <ion-col>
                <ion-button expand="block" color="success" @click="submit()">
                  <ion-icon slot="start" :icon="save"></ion-icon>
                  Save
                </ion-button>
              </ion-col>
            </ion-row>
          </ion-grid>
        </section>
      </div>
    </ion-footer>
    <ion-loading :is-open="state.loading" message="Please wait...">
    </ion-loading>
  </ion-page>
</template>
